/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ViewAdminWrapper } from "../../components/ManageAdmin/style";
import {
    Heading,
    IconInactive,
    TableWarpper,
    Text,
    IconView,
    ButtonSolid
} from "../../components/styledConstants";
import FilterBox from "../../components/common/FilterBox";
import Pagination from "../../components/common/Pagination";
import ItemPerPage from "../../components/common/ItemPerPage";
import TableLoader from "../../components/common/TableLoader";
import Request from "../../utils/Request";
import Config from "../../utils/config";
import IconActive from "../../assets/images/IconActive";
import { FilterWrapper } from "./style";
import CsvDown from "../../components/ExportFiles/CsvDown";
import PdfDown from "../../components/ExportFiles/PdfDown";
import { BlockPayInWrapper } from "../../components/MerchantDetail/PaymentSettings/style";
import SuccessMessage from "../../components/SuccessMessage";
import ErrorMessage from "../../components/ErrorMessage";

const filterForm = [
    { name: "name", type: "text", placeholder: "Name", value: "" },

    { name: "email", type: "text", placeholder: "Email", value: "" },

    { name: "orgCode", type: "text", placeholder: "Org Code", value: "" },

    { name: "mobileNo", type: "text", placeholder: "Mobile Number", value: "" },

    {
        name: "status",
        type: "select",
        placeholder: "Status",
        value: "",
        options: [
            { value: "", label: "All" },
            { value: "ACTIVE", label: "Active" },
            { value: "INACTIVE", label: "Inactive" },
        ],
    },

    {
        name: "agentStatus",
        type: "select",
        placeholder: "Agent Status",
        value: "",
        options: [
            { value: "", label: "All" },
            { value: "true", label: "Active" },
            { value: "false", label: "Inactive" },
        ],
    },
];

export default function FosUserList() {
    const [controls, setControls] = useState([...filterForm]);
    const [data, setData] = useState([]);
    const [allData, setAllData] = useState([]);
    const [loader, setLoader] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalPages, setTotalPages] = useState(1);
    const [message, setMessage] = useState({ success: "", error: "" });

    const headers = [
        { label: "Name", key: "name" },
        { label: "Email", key: "email" },
        { label: "Mobile Number", key: "mobileNo" },
        { label: "Registered On", key: "createdAt" },
        { label: "App Access", key: "status" },
        { label: "Org Code", key: "orgCode" },
        { label: "Risk Category", key: "riskCategory" },
        { label: "Agent Status", key: "agentStatus" },
        { label: "Created By", key: "createdBy.name" },
    ];

    const tableHeader = [
        {
            name: "Name",
            email: "Email",
            mobileNo: "Mobile Number",
            createdAt: "Registered On",
            status: "Status",
            orgCode: "Org Code",
            riskCategory: "Risk Category",
            createdBy: "Created By"
        }
    ];

    const getTableBody = (data) =>
        data.map((user) => ({
            name: user?.name || "-",
            email: user?.email || "-",
            mobileNo: user?.mobileNo || "-",
            createdAt: user?.createdAt
                ? user.createdAt.split("T")[0] +
                " " +
                user.createdAt.split("T")[1]?.split(".")?.[0]
                : "-",
            status: user?.status || "-",
            orgCode: user?.orgCode || "-",
            riskCategory: user?.riskCategory || "-",
            createdBy: user?.createdBy?.name || "-"
        }));

    const renderStatus = (data) => {
        const status = data?.toLowerCase();
        switch (status) {
            case "active":
                return (
                    <div className="flex flex-center">
                        <IconActive width="13" className="align-top mr6" color="#2AC940" />
                        <Text size="xsm" fw="medium" color="color10">
                            {data}
                        </Text>
                    </div>
                );
            case "inactive":
                return (
                    <div className="flex flex-center">
                        <IconInactive width="12px" className="align-top mr6" />
                        <Text size="xsm" fw="medium" color="color4">
                            {data}
                        </Text>
                    </div>
                );
            case "unverified":
                return (
                    <div className="flex flex-center">
                        <IconInactive width="12px" className="align-top mr6" />
                        <Text size="xsm" fw="medium" color="color4">
                            {data}
                        </Text>
                    </div>
                );
            case "suspended":
                return (
                    <div className="flex flex-center">
                        <IconInactive width="12px" className="align-top mr6" color="color11" />
                        <Text size="xsm" fw="medium" color="color11">
                            {data}
                        </Text>
                    </div>
                );
        }
    };

    const fetchFosList = () => {
        setLoader(true);
        const successHandler = (res) => {
            setLoader(false);
            const list = res?.data?.content || res?.data || [];
            setAllData(list);
            setData(list);
        };

        const errorHandler = () => setLoader(false);

        const api = new Request("", successHandler, errorHandler, false);

        api.get(Config.apis.admin.FOS_LIST);
    };

    useEffect(() => {
        refreshPage();
        fetchFosList();
    }, []);

    const onFilterChange = (event, index) => {
        const _controls = [...controls];
        let value =
            event instanceof Date || event?.label
                ? event
                : event?.target?.value;

        if (_controls[index].name === "mobileNo") {
            value = value.replace(/\D/g, "").slice(0, 10);
        }
        _controls[index].value = value;
        setControls(_controls);
    };

    const applyFilters = (e) => {
        if (e) e.preventDefault();

        let filtered = [...allData];

        const getValue = (name) => {
            const control = controls.find((c) => c.name === name);
            if (!control) return "";

            const value = control.value;

            if (value && typeof value === "object") {
                return value.value ?? "";
            }

            return value ?? "";
        };

        const normalize = (v) =>
            (v || "").toString().toLowerCase().trim();

        const name = normalize(getValue("name"));
        const email = normalize(getValue("email"));
        const orgCode = normalize(getValue("orgCode"));
        const status = normalize(getValue("status"));
        const agentStatus = getValue("agentStatus");
        const mobileNo = normalize(getValue("mobileNo"));

        if (name) {
            filtered = filtered.filter((u) =>
                normalize(u?.name).includes(name)
            );
        }

        if (email) {
            filtered = filtered.filter((u) =>
                normalize(u?.email).includes(email)
            );
        }

        if (orgCode) {
            filtered = filtered.filter((u) =>
                normalize(u?.orgCode).includes(orgCode)
            );
        }

        if (status) {
            filtered = filtered.filter(
                (u) => normalize(u?.status) === status
            );
        }

        if (agentStatus !== "") {
            filtered = filtered.filter(
                (u) => String(u?.isAgentActive) === agentStatus
            );
        }

        if (mobileNo) {
            filtered = filtered.filter((u) =>
                normalize(u?.mobileNo).includes(mobileNo)
            );
        }

        setCurrentPage(1);
        setData(filtered);
    };

    const paginatedData = data.slice(
        (currentPage - 1) * pageSize,
        currentPage * pageSize
    );

    useEffect(() => {
        setTotalPages(Math.ceil(data.length / pageSize) || 1);
    }, [data, pageSize]);

    const refreshPage = () => {
        const resetControls = filterForm.map((item) => ({
            ...item,
            value: "",
        }));

        setControls(resetControls);
        setData(allData);
        setCurrentPage(1);
    };

    const toggleAgentStatus = (userId, isActive, isMufinFos) => {
        const successHandler = (res) => {
            const response =
                res?.data ||
                res ||
                {};

            if (response?.code && response.code !== "0000") {
                setMessage({
                    success: "",
                    error:
                        response?.message ||
                        response?.msg ||
                        "Something went wrong!"
                });
                return;
            }

            if (!response || Object.keys(response).length === 0) {
                setMessage({
                    success: "",
                    error: "Invalid response from server"
                });
                return;
            }

            setMessage({
                success: "FOS Updated Successfully",
                error: ""
            });

            fetchFosList();
        };

        const errorHandler = (err) => {
            setMessage({
                success: "",
                error: err?.data?.message || err?.message || "Something went wrong!"
            });
        };

        setMessage({ success: "", error: "" });

        const api = new Request("", successHandler, errorHandler, false);

        const baseUrl = `${Config.apis.admin.FOS_AGENT_MANAGE}?userId=${userId}&isActive=${isActive}`;

        let url = baseUrl;

        if (typeof isMufinFos === "boolean") {
            url = `${baseUrl}&isMufinFos=${isMufinFos}`;
        }
        api.post(url);
    };

    useEffect(() => {
        setCurrentPage(1);
    }, [pageSize]);

    return (
        <>
            <div className="flex flex-center space-between mb10">
                <Heading size="xxl" color="color7">
                    FOS User List
                </Heading>

                <div className="flex flex-center">
                    <div className="mr20">
                        <CsvDown
                            headers={headers}
                            url={Config.apis.admin.FOS_LIST}
                            title="CSV"
                            method="get"
                        />
                    </div>

                    <PdfDown
                        heading="FOS User List"
                        tableHeader={tableHeader}
                        getTableBody={getTableBody}
                        url={Config.apis.admin.FOS_LIST}
                        method="get"
                    />
                </div>
            </div>


            <ViewAdminWrapper>
                <FilterWrapper>
                    <FilterBox
                        filterForm={controls}
                        onFilterChange={onFilterChange}
                        onFilterSubmit={(e) => {
                            e.preventDefault();
                            applyFilters();
                        }}
                        refreshPage={refreshPage}
                    />
                </FilterWrapper>
                {message.success && <SuccessMessage successMessage={message.success} />}
                {message.error && (
                    <ErrorMessage error={message.error} />
                )}
                <TableWarpper className="mt24">
                    <table className="table">
                        <thead>
                            <tr>
                                <th className="text-left">
                                    <Text size="rg" color="color7" fw="medium">
                                        Name
                                    </Text>
                                </th>

                                <th className="text-left">
                                    <Text size="rg" color="color7" fw="medium">
                                        Email
                                    </Text>
                                </th>

                                <th className="text-left">
                                    <Text size="rg" color="color7" fw="medium">
                                        Mobile Number
                                    </Text>
                                </th>

                                <th className="text-left">
                                    <Text size="rg" color="color7" fw="medium">
                                        Registered On
                                    </Text>
                                </th>

                                <th className="text-left">
                                    <Text size="rg" color="color7" fw="medium">
                                        App Access
                                    </Text>
                                </th>

                                <th className="text-left">
                                    <Text size="rg" color="color7" fw="medium">
                                        Org Code
                                    </Text>
                                </th>

                                <th className="text-left">
                                    <Text size="rg" color="color7" fw="medium">
                                        Risk Category
                                    </Text>
                                </th>

                                <th className="text-left">
                                    <Text size="rg" color="color7" fw="medium">
                                        Agent Status
                                    </Text>
                                </th>

                                <th className="text-left">
                                    <Text size="rg" color="color7" fw="medium">
                                        Activated At
                                    </Text>
                                </th>

                                <th className="text-left">
                                    <Text size="rg" color="color7" fw="medium">
                                        Deactivated At
                                    </Text>
                                </th>

                                <th className="text-left">
                                    <Text size="rg" color="color7" fw="medium">
                                        Created By
                                    </Text>
                                </th>

                                <th className="text-left">
                                    <Text size="rg" color="color7" fw="medium">
                                        MUFIN FOS
                                    </Text>
                                </th>

                                <th className="text-left">
                                    <Text size="rg" color="color7" fw="medium">
                                        DTC FOS
                                    </Text>
                                </th>

                                <th className="text-left">
                                    <Text size="rg" color="color7" fw="medium">
                                        Action
                                    </Text>
                                </th>

                                <th className="text-left">
                                    <Text size="rg" color="color7" fw="medium">
                                        User Details
                                    </Text>
                                </th>
                            </tr>
                        </thead>

                        <tbody>
                            {loader && <TableLoader />}

                            {!loader && data.length ? (
                                paginatedData.map((user, idx) => {
                                    const org = user?.orgCode?.toUpperCase() || "";

                                    const isMufin = org === "MUFIN_FOS";
                                    const isDtc = org === "DTC_FOS";

                                    return (
                                        <tr key={idx}>
                                            <td>
                                                <Text size="xsm" color="#828282">
                                                    {user?.name || "-"}
                                                </Text>
                                            </td>

                                        <td>
                                            <Text size="xsm" color="#828282">
                                                {user?.email || "-"}
                                            </Text>
                                        </td>

                                        <td>
                                            <Text size="xsm" color="#828282">
                                                {user?.mobileNo || "-"}
                                            </Text>
                                        </td>

                                        <td>
                                            <Text size="xsm" color="#828282">
                                                {user?.createdAt
                                                    ? user.createdAt.split("T")[0] +
                                                    " " +
                                                    user.createdAt.split("T")[1]?.split(".")?.[0]
                                                    : "-"}
                                            </Text>
                                        </td>

                                        <td>
                                            <Text size="xsm" color="#828282">
                                                {renderStatus(user?.status)}
                                            </Text>
                                        </td>

                                        <td>
                                            <Text size="xsm" color="#828282">
                                                {user?.orgCode || "-"}
                                            </Text>
                                        </td>

                                        <td>
                                            <Text
                                                size="xsm"
                                                color="#828282"
                                                style={{ textTransform: "uppercase" }}
                                            >
                                                {user?.riskCategory || "-"}
                                            </Text>
                                        </td>

                                        <td>
                                            <Text size="xsm" color="#828282">
                                                {user?.isAgentActive ? "ACTIVE" : "INACTIVE"}
                                            </Text>
                                        </td>

                                        <td>
                                            <Text size="xsm" color="#828282">
                                                {user?.agentActivatedAt
                                                    ? user.agentActivatedAt.split("T")[0] +
                                                    " " +
                                                    user.agentActivatedAt.split("T")[1]?.split(".")?.[0]
                                                    : "-"}
                                            </Text>
                                        </td>

                                        <td>
                                            <Text size="xsm" color="#828282">
                                                {user?.agentDeactivatedAt
                                                    ? user.agentDeactivatedAt.split("T")[0] +
                                                    " " +
                                                    user.agentDeactivatedAt.split("T")[1]?.split(".")?.[0]
                                                    : "-"}
                                            </Text>
                                        </td>

                                        <td>
                                            <Text size="xsm" color="#828282">
                                                {user?.createdBy?.name || "-"}
                                            </Text>
                                        </td>

                                            <td>
                                                <BlockPayInWrapper>
                                                    <div className="toggle-with-label flex flex-center space-between"
                                                        style={{
                                                            padding: 0,
                                                            margin: 0,
                                                            height: "17px",
                                                            marginLeft: "5px",
                                                            width: "40px",
                                                        }}
                                                    >
                                                        <label className="switch">
                                                            <input
                                                                type="checkbox"
                                                                checked={isMufin}
                                                                disabled={isMufin}
                                                                onChange={() => {
                                                                    if (!isMufin) {
                                                                        toggleAgentStatus(
                                                                            user.id,
                                                                            true,
                                                                            true
                                                                        );
                                                                    }
                                                                }}
                                                            />
                                                            <span className="slider round" style={{
                                                                cursor: isMufin
                                                                    ? "not-allowed"
                                                                    : "pointer"
                                                            }}></span>
                                                        </label>
                                                    </div>
                                                </BlockPayInWrapper>
                                            </td>

                                            <td>
                                                <BlockPayInWrapper>
                                                    <div className="toggle-with-label flex flex-center space-between"
                                                        style={{
                                                            padding: 0,
                                                            margin: 0,
                                                            height: "17px",
                                                            marginLeft: "5px",
                                                            width: "40px",
                                                        }}
                                                    >
                                                        <label className="switch">
                                                            <input
                                                                type="checkbox"
                                                                checked={isDtc}
                                                                disabled={isDtc}
                                                                onChange={() => {
                                                                    if (!isDtc) {
                                                                        toggleAgentStatus(
                                                                            user.id,
                                                                            true,
                                                                            false
                                                                        );
                                                                    }
                                                                }}
                                                            />
                                                            <span className="slider round" style={{
                                                                cursor: isDtc
                                                                    ? "not-allowed"
                                                                    : "pointer"
                                                            }}></span>
                                                        </label>
                                                    </div>
                                                </BlockPayInWrapper>
                                            </td>

                                            <td>
                                                {(isMufin || isDtc) ? (
                                                    <ButtonSolid
                                                        primary
                                                        style={{ borderRadius: "0.15rem", padding: "0.25rem" }}
                                                        onClick={() => {
                                                            toggleAgentStatus(
                                                                user.id,
                                                                false
                                                            );
                                                        }}
                                                    >
                                                        Revoke
                                                    </ButtonSolid>
                                                ) : (
                                                    <Text size="xsm" color="#828282">-</Text>
                                                )}
                                            </td>

                                            <td>
                                                <Link
                                                    to={`/merchant-detail/${user?.id}/ncmc_user`}
                                                    className="flex flex-center"
                                                    style={{ justifyContent: "center" }}
                                                >
                                                    <IconView />
                                                </Link>
                                            </td>
                                        </tr>
                                    )
                                })
                            ) : (
                                !loader && (
                                    <tr>
                                        <td colSpan="7" style={{ textAlign: "center" }}>
                                            No records found
                                        </td>
                                    </tr>
                                )
                            )}
                        </tbody>
                    </table>
                </TableWarpper>

                <div className="mt24 flex flex-center">
                    <ItemPerPage pageSize={pageSize} getPageSize={setPageSize} />
                    {totalPages > 1 && (
                        <Pagination
                            totalPages={totalPages}
                            currentPage={currentPage}
                            getCurrentPageData={setCurrentPage}
                        />
                    )}
                </div>
            </ViewAdminWrapper >
        </>
    );
}
